import { Box } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * BorderedContainer Component
 * 
 * A responsive container with gradient background and precise specifications.
 * Adapts to different screen sizes while maintaining design consistency.
 * 
 * @component
 * @example
 * <BorderedContainer>
 *   <Typography>Your content here</Typography>
 * </BorderedContainer>
 */

const BorderedContainer = ({ children }) => {
  return (
    <Box
      sx={{
        // Responsive width
        width: {
          xs: '100%',           // Mobile: Full width
          sm: '90%',            // Tablet: 90% width
          md: '900px',          // Medium: 900px
          lg: '1200px',         // Large: 1200px (original)
        },
        // Responsive height
        height: {
          xs: 'auto',           // Mobile: Auto height
          sm: 'auto',           // Tablet: Auto height
          md: '371px',          // Medium: Fixed height
          lg: '371px',          // Large: Fixed height (original)
        },
        minHeight: {
          xs: '250px',          // Mobile: Minimum height
          sm: '300px',          // Tablet: Minimum height
        },
        // Responsive border
        border: {
          xs: '2px solid #28C76F',  // Mobile: Thinner border
          sm: '3px solid #28C76F',  // Tablet: Medium border
          md: '4px solid #28C76F',  // Desktop: Original border
        },
        // Responsive border radius
        borderRadius: {
          xs: '12px',           // Mobile: Smaller radius
          sm: '14px',           // Tablet: Medium radius
          md: '16px',           // Desktop: Original radius
        },
        // Responsive padding
        padding: {
          xs: '20px 16px',      // Mobile: Compact padding
          sm: '30px 32px',      // Tablet: Medium padding
          md: '40px 54px',      // Desktop: Original padding
        },
        // Responsive gap
        gap: {
          xs: '24px',           // Mobile: Smaller gap
          sm: '40px',           // Tablet: Medium gap
          md: '64px',           // Desktop: Original gap
        },
        opacity: 1,
        display: 'flex',
        // Responsive flex direction
        flexDirection: {
          xs: 'column',         // Mobile: Stack vertically
          sm: 'column',         // Tablet: Stack vertically
          md: 'row',            // Desktop: Horizontal layout
        },
        transform: 'rotate(0deg)',
        // Responsive max width for very large screens
        maxWidth: '1200px',
        // Center on smaller screens
        margin: {
          xs: '0 auto',
          sm: '0 auto',
        },
      }}
    >
      {children}
    </Box>
  );
};

BorderedContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BorderedContainer;